import type {
  AttachmentUniversalChatMessage,
  ChatParticipant,
  ResourceUniversalChatMessage,
  TextUniversalChatMessage,
  UniversalChatMessage as UniversalChatMessageType,
} from "../types/universalChatTypes";
import { AttachmentMessage } from "./AttachmentMessage";
import { ResourceMessage } from "./ResourceMessage";
import { TextMessage } from "./TextMessage";
import { normalizeMessageType } from "./messageUtils";

interface UniversalChatMessageProps {
  message: UniversalChatMessageType;
  includeAvatar?: boolean;
  participants?: ChatParticipant[];
}

export const UniversalChatMessage = ({
  message,
  includeAvatar = false,
  participants = [],
}: UniversalChatMessageProps) => {
  // Normalize message type to handle both string and number representations
  const messageType = normalizeMessageType(message.type);

  // Find the participant for this message
  const participant = participants.find((p) => p.id === message.senderId);

  // Switch based on message type, then each component handles sender type internally
  switch (messageType) {
    case "text":
      return (
        <TextMessage
          message={message as TextUniversalChatMessage}
          includeAvatar={includeAvatar}
          participant={participant}
        />
      );

    case "resource":
      return (
        <ResourceMessage
          message={message as ResourceUniversalChatMessage}
          includeAvatar={includeAvatar}
          participant={participant}
        />
      );

    case "attachment":
      return (
        <AttachmentMessage
          message={message as AttachmentUniversalChatMessage}
          includeAvatar={includeAvatar}
          participant={participant}
        />
      );

    default:
      // Fallback to text message for unknown types
      return (
        <TextMessage
          message={message as TextUniversalChatMessage}
          includeAvatar={includeAvatar}
          participant={participant}
        />
      );
  }
};
